export const MOUSE_EVENT_TYPES = [
    'mousedown',
    'mouseup',
    'mousemove',
];
export const TOUCH_EVENT_TYPES = [
    'touchstart',
    'touchend',
    'touchmove',
];
